<template>
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.5 10C5.6715 10 5 9.3285 5 8.5C5 7.8475 5.419 7.2985 6 7.092V4.5C6 4.224 6.2235 4 6.5 4C6.7765 4 7 4.224 7 4.5V7.092C7.581 7.2985 8 7.8475 8 8.5C8 9.3285 7.3285 10 6.5 10ZM6.995 2.02499L7 1H9C9.2765 1 9.5 0.7765 9.5 0.5C9.5 0.2235 9.2765 0 9 0H4C3.7235 0 3.5 0.2235 3.5 0.5C3.5 0.7765 3.7235 1 4 1H6V2L6.005 2.02499C2.6475 2.27899 0 5.077 0 8.5C0 12.09 2.91 15 6.5 15C10.09 15 13 12.09 13 8.5C13 5.077 10.3525 2.27899 6.995 2.02499Z"
      :fill="'var(--secondary-c600)'"
    />
  </svg>
</template>